import { Action } from 'redux';
import { DashboardNotifications } from '@dev/ee-api/ee-api-models';

export enum DashboardSeenNotificationsActionTypes {
    GET_DASHBOARD_SEEN_NOTIFICATIONS = '@@dashboardseennotifications/GET_DASHBOARD_SEEN_NOTIFICATIONS',
    GET_DASHBOARD_SEEN_NOTIFICATIONS_SUCCESS = '@@dashboardseennotifications/GET_DASHBOARD_SEEN_NOTIFICATIONS_SUCCESS',
    UPDATE_DASHBOARD_SEEN_NOTIFICATION = '@@dashboardseennotifications/GET_DASHBOARD_SEEN_NOTIFICATION',
}

export interface GetDashboardSeenNotificationsAction extends Action {
    type: DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS;
}

export interface GetDashboardSeenNotificationsSuccessAction extends Action {
    type: DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS_SUCCESS;
    payload: {
        notifications: DashboardNotifications[];
    };
}

export interface UpdateDashboardSeenNotificationAction extends Action {
    type: DashboardSeenNotificationsActionTypes.UPDATE_DASHBOARD_SEEN_NOTIFICATION;
    payload: {
        notification: DashboardNotifications;
    };
}

export interface DashboardSeenNotificationsState {
    list?: DashboardNotifications[];
    isLoaded: boolean;
}
